const teamApplicationStatuses = {
  new: {
    id: 1,
    title: 'new'
  },
  accepted: {
    id: 2,
    title: 'accepted'
  },
  rejected: {
    id: 3,
    title: 'rejected'
  }
};

export default teamApplicationStatuses;



// WEBPACK FOOTER //
// ./src/components/teamApplicationStatuses.js